import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { relatorioAction } from '../../store/relatorio';

//HELPERS
import * as c from '../../helpers/constants';
import { callApi } from '../../helpers/methods';
import { isBlank } from '../../helpers/stringHelper';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import {Row, Column, IBox, Title, Content, Button, Icon, Select, SelectCentroCusto} from '../inspinia';
import Pagination from "react-js-pagination";
import Table from './tableDetalheContato'
import TableNaoRecebidos from './tableResumoNaoRecebidos';
import TableEnvioLeitura from './tableResumoEnvioLeitura';
import TableVolumetria from './tableVolumetria';
import TableDetalheContatoSmsUnico from './tableDetalheContatoSmsUnico';
import TableEmailsValidadosOuInvalidos from './tableEmailsvalidadosOuInvalidos';
import TableEnvioLeituraPorCampanha from './tableResumoEnvioLeituraPorCampanha';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TableDetalheContatoSms from './tableDetalheContatoSms';

//MASK
import InputMask from 'react-input-mask';

//EXPORT
import TableToExcel from 'react-html-table-to-excel';
import TableVolumetriaEmailsValidados from './tableVolumetriaEmailsValidados';
import TableCampanhaAdesao from './tableCampanhaAdesao';
import TemPermissao from '../../helpers/TemPermissao';
import { ROLE_EMAIL} from '../../store/roles';
import { CAMPANHA } from '../../store/tipoListaEnvioProduto';


class EnvioRastreado extends React.PureComponent
{
    
    constructor(props)
    {
        super(props);    
    
        this.state = {
            ...this.defaultInitialState(),
            isGoing: true,
            novoAcesso: true,
            loading: false,
            pageInit: 0,
            isLoggedIn: true,
            tableAux: "",
            labelDataInicio: "Data do envio da campanha (Início):",
            labelDataFim: "Data do envio da campanha (Fim):",
            labelDataInicioCampanha: "Data do envio da campanha (Início):",
            labelDataFimCampanha: "Data do envio da campanha (Fim):",
            labelDataInicioEmailsValidados: "Data da validação dos e-mails (Início):",
            labelDataFimEmailsValidados: "Data da validação dos e-mails (Fim):",
            labelEmailOuTelefone: "Contato:",
                                    
            form: this.formInitialState(),
            listaDetalheContatoSms: [],
            list: this.listInitialState(),
            comboEmpresa: 
            {
                results: undefined
            },
            comboStatus: 
            {
                results: undefined
            }, 
            comboTipoRelatorio: 
            {
                results: undefined
            },
            comboMotivos: 
            {
                results: undefined
            }, 
            comboCentroCusto: 
            {
                results: undefined
            },
            comboNomeCampanhas:
            {
                results: undefined
            }, 
            comboNomeCampanhasAutoComplete: [],
            campanhaValues: {
                value: "",
                label: ""
            },

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
        }

        this.handlePesquisarRelatorio = this.handlePesquisarRelatorio.bind(this);
        this.handleChange             = this.handleChange.bind(this);
        this.handlePageChange         = this.handlePageChange.bind(this);
        this.handleChangeCombo        = this.handleChangeCombo.bind(this);
        this.handleLimparPesquisa     = this.handleLimparPesquisa.bind(this);
        this.handlePesquisarRelatorioEmail = this.handlePesquisarRelatorioEmail.bind(this);
        this.onNomeCampanhaChange = this.onNomeCampanhaChange.bind(this);
        this.paginacaoDetalhePorContatoSms = this.paginacaoDetalhePorContatoSms.bind(this);
        this.verificaData = this.verificaData.bind(this);
    }

    defaultInitialState () {
        return {
            combosDisabled: false,
            comboDisableUnico: false,
            botaoDisabled: false,
            comboMotivoDisabled: false,
            comboDataDisabled:false,
            comboCentroCustoDisabled: false,
            comboEmpresaDisabled: false
        }
    }

    formInitialState () 
    {
        return {
            campanha: "",
            nomeCampanha: "",
            empresa: { },
            nomeContato: "",
            status: "",
            email: "",
            motivo: "",
            dataInicio: "",
            dataFim: "",
            tipoRelatorio: "",
            tipoEnvio: 'Rastreado',
            centroCusto: "",
        }
    }

    listInitialState() {
        return {
            currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, results: undefined
        }
    }

    componentDidMount() {   
        this.LoadComboEmpresa();
        this.LoadComboNomeCampanhas();
        this.LoadComboMotivos();
        this.LoadComboTipoRelatorio();
    }

    handleChange(e) {
        const valor = e.target.value === "Selecione..." ? 0 : e.target.value;
        const form = this.state.form;
        this.state.isLoggedIn = false;

        if (e.target.name === "empresa") {
            this.setState(prevState => {
                const inputs = { ...prevState.form };

                inputs.empresa.id = parseInt(valor);
                this.LoadListaCentroCusto(inputs.empresa.id);
                return { inputs }
            });
        } else {
            this.setState({ form: { ...form, [e.target.name]: e.target.value } });
        }

    }

    onNomeCampanhaChange = (event, values) => {
        let campanhaCombo = '';
        let nomeCampanhaCombo = '';
        const opcao = {
            value: '',
            label: ''
        }
        
        if (values) {
            opcao.value = values.value;
            opcao.label = values.label;
            campanhaCombo = opcao.value;
            nomeCampanhaCombo = opcao.label;
        }
        
        this.state.form.campanha = campanhaCombo;
        this.state.form.nomeCampanha = nomeCampanhaCombo;
        this.setState({ ...this.state, campanhaValues: opcao });
    }

    handleChangeCombo(e) {
        this.state.isLoggedIn = false;
        this.state.form.tipoRelatorio = e.target.value;

        const tipo = e.target.value;

        this.setState((prevState) => {
            let newState = { ...prevState };
    
            newState.form.tipoRelatorio = tipo;

        if (tipo == 7) {
            newState.botaoDisabled = true;
            newState.combosDisabled = true;
            newState.comboDisableUnico = false;
            newState.comboMotivoDisabled = true;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = this.state.labelDataInicioEmailsValidados;
            newState.labelDataFim =  this.state.labelDataFimEmailsValidados;
        } else if (tipo == 0) {
            newState.botaoDisabled = false;
            newState.combosDisabled = false;
            newState.comboDisableUnico = false;
            newState.comboMotivoDisabled = false;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = this.state.labelDataInicioCampanha;
            newState.labelDataFim = this.state.labelDataFimCampanha;
        } else if (tipo == 1) {
            newState.botaoDisabled = true;
            newState.combosDisabled = true;
            newState.comboDisableUnico = false;
            newState.comboMotivoDisabled = true;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = prevState.labelDataInicioCampanha;
            newState.labelDataFim = prevState.labelDataFimCampanha;
        } else if (tipo == 2) {
            newState.botaoDisabled = true;
            newState.combosDisabled = true;
            newState.comboDisableUnico = true;
            newState.comboMotivoDisabled = false;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = this.state.labelDataInicioCampanha;
            newState.labelDataFim = this.state.labelDataFimCampanha;
        } else if (tipo == 3) {
            newState.botaoDisabled = true;
            newState.combosDisabled = true;
            newState.comboDisableUnico = false;
            newState.comboMotivoDisabled = true;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = this.state.labelDataInicioCampanha;
            newState.labelDataFim = this.state.labelDataFimCampanha;
        } else if (tipo == 4) {
            newState.botaoDisabled= true;
            newState.combosDisabled = true;
            newState.comboDisableUnico = false;
            newState.comboMotivoDisabled = true;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = this.state.labelDataInicioCampanha;
            newState.labelDataFim = this.state.labelDataFimCampanha;
        } else if (tipo == 5) {
            newState.botaoDisabled = true;
            newState.combosDisabled = false;
            newState.comboDisableUnico = false;
            newState.comboMotivoDisabled = false;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = this.state.labelDataInicioCampanha;
            newState.labelDataFim = this.state.labelDataFimCampanha;
        } else if (tipo == 6) {
            newState.botaoDisabled = true;
            newState.combosDisabled = false;
            newState.comboDisableUnico = false;
            newState.comboMotivoDisabled = false;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = this.state.labelDataInicioCampanha;
            newState.labelDataFim = this.state.labelDataFimCampanha;
        } else if (tipo == 9) {
            newState.botaoDisabled = false;
            newState.combosDisabled = false;
            newState.comboDisableUnico = false;
            newState.comboMotivoDisabled = true;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = this.state.labelDataInicioCampanha;
            newState.labelDataFim = this.state.labelDataFimCampanha;
        } else if (tipo == 10) {
            newState.botaoDisabled = true;
            newState.combosDisabled = true;
            newState.comboDisableUnico = false;
            newState.comboMotivoDisabled = true;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = this.state.labelDataInicioCampanha;
            newState.labelDataFim = this.state.labelDataFimCampanha;
        } else if (tipo == 11) {
            newState.botaoDisabled = false;
            newState.combosDisabled = false;
            newState.comboDisableUnico = true;
            newState.comboMotivoDisabled = true;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = "Data do envio (Início):";
            newState.labelDataFim = "Data do envio (Fim):";
        } else if (tipo == 8) {
            newState.botaoDisabled = true;
            newState.comboDisableUnico = false;
            newState.comboMotivoDisabled = true;
            newState.combosDisabled = true;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = "Data do envio (Início):";
            newState.labelDataFim = "Data do envio (Fim):";
        } else {
            newState.botaoDisabled = true;
            newState.combosDisabled = false;
            newState.comboDisableUnico = false;
            newState.comboMotivoDisabled = false;
            newState.comboCentroCustoDisabled = false;
            newState.labelDataInicio = this.state.labelDataInicioCampanha;
            newState.labelDataFim = this.state.labelDataFimCampanha;
        } 

        newState.form = this.clearDisabledFields(newState);
        if (newState.comboDisableUnico) {
            newState.campanhaValues = { value: "", label: "" };
        }

        return newState;
    });
    }

    clearDisabledFields(state) {
        const newForm = { ...state.form };
        
        if (state.combosDisabled) {
            newForm.empresa = {}; 
            newForm.nomeContato = "";
            newForm.status = "";
        }
    
        if (state.comboMotivoDisabled) {
            newForm.motivo = "";
        }
    
        if (state.comboCentroCustoDisabled) {
            newForm.centroCusto = "";
        }
    
        if (state.comboDisableUnico) {
            this.state.campanhaValues  = { value: "", label: "" };
            newForm.campanha =  "";
            newForm.nomeCampanha = "";
        }
    
        return newForm;
    }

    handlePesquisarRelatorio() {
        if (this.state.loading) {
            return;
        }

        this.setState({
            isLoggedIn: true,
            page: 1
        }, () => {
            this.handleRelatorio();
        });
    }

    handlePesquisarRelatorioEmail() {  
        this.state.list = [];
        this.state.isLoggedIn = true;
        this.state.page = 1;
        this.handleRelatorioEmail();
     }

     handleLimparPesquisa() {
        if (this.state.loading) {
            return;
        }
    
        this.setState({
            loading: true,
            ...this.defaultInitialState(),
            list: {
                currentPage: 0,
                pageCount: 0,
                pageSize: 0,
                rowCount: 0,
                results: undefined
            },
            form: this.formInitialState(),
            campanhaValues: { value: "", label: "" },
            comboCentroCusto: {
                results: undefined
            },
            loading: false,
        });
    }
    

    handlePageChange(pageNumber) {
        this.state.page = pageNumber;
        this.handleRelatorio(pageNumber);
    }

    handleRelatorio(pageNumber) {
        this.state.list = [];
        this.LoadTable(pageNumber);
    }

    handleRelatorioEmail() {
        this.LoadTableEmail();
    }

    render()
    {
        const form = this.state.form;
        const campanhas = this.state.comboNomeCampanhasAutoComplete;          
        const isLoggedIn = this.state.isLoggedIn;
        let table;

        if( isLoggedIn ) {

            if(form.tipoRelatorio === "0"){
                table  = <Table data={this.state.list} history={this.props.history} loading={this.state.loading}/>; 
            } else if(form.tipoRelatorio === "1"){
                table  = <TableEnvioLeitura data={this.state.list} history={this.props.history} loading={this.state.loading}/>;
            } else if(form.tipoRelatorio === "2") {
                table  = <TableNaoRecebidos data={this.state.list} history={this.props.history} loading={this.state.loading}/>;
            } else if(form.tipoRelatorio === "3" || form.tipoRelatorio === "10") {
                table  = <TableVolumetria data={this.state.list} history={this.props.history} loading={this.state.loading}/>;
            }else if(form.tipoRelatorio === "4") {
                table  = <TableEnvioLeituraPorCampanha data={this.state.list} history={this.props.history} loading={this.state.loading}/>;
            } else if(form.tipoRelatorio === "5") {
                table = <TableEmailsValidadosOuInvalidos data={this.state.list} history={this.props.history} tipoRelatorio={form.tipoRelatorio} loading={this.state.loading} />
            } else if(form.tipoRelatorio === "6") {
                table = <TableEmailsValidadosOuInvalidos data={this.state.list} history={this.props.history} tipoRelatorio={form.tipoRelatorio} loading={this.state.loading} />
            } else if (form.tipoRelatorio === "7") {
                table = <TableVolumetriaEmailsValidados data={this.state.list} history={this.props.history} loading={this.state.loading} />;
            } else if (form.tipoRelatorio === "8") {
                table = <TableCampanhaAdesao data={this.state.list} history={this.props.history} loading={this.state.loading} />;
            } else if (form.tipoRelatorio === "9") {
                table  = <TableDetalheContatoSms data={this.state.list} history={this.props.history} loading={this.state.loading}/>;
            }else if(form.tipoRelatorio === "11"){
                table = <TableDetalheContatoSmsUnico data={this.state.list} history={this.props.history} loading={this.state.loading}/>;
            }

            this.state.tableAux = table;
        }else {
            table = this.state.tableAux;
        }

        return (            
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Envio Rastreado - Buscar relatório</h3>
                            </Title>
                            
                            <Content>
                                <Row className="form-row">
                                    <div className="form-group col-md-6">
                                        <label>Campanha:</label>     
                                        <Autocomplete
                                            id="combo-campanha"
                                            options={campanhas}
                                            getOptionLabel={(option) => option.label}
                                            style={{marginTop:-8}}
                                            onChange={this.onNomeCampanhaChange}
                                            disabled={this.state.comboDisableUnico}
                                            value={this.state.campanhaValues}
                                            getOptionSelected={(option) => option.value}
                                            renderInput={
                                                (params) => 
                                                <TextField 
                                                    {...params} 
                                                    variant="outlined"  
                                                    margin="dense"
                                                /> 
                                            }
                                        /> 
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>Empresa:</label>
                                        <Select name="empresa" selected={form.empresa.id} data={this.state.comboEmpresa} onChange={this.handleChange} placeholder="Empresa" disabled={this.state.comboEmpresaDisabled } />
                                    </div>                                    
                                </Row> 

                                <Row className="form-row">
                                    <div className="form-group col-md-4">
                                        <label>Nome Contato:</label>     
                                        <input type="text" name="nomeContato" value={form.nomeContato} onChange={this.handleChange} className="form-control" disabled={this.state.combosDisabled } />
                                    </div>
                                    
                                    <div className="form-group col-md-4">
                                        <label>{ this.state.labelEmailOuTelefone }</label>
                                        <input type="text" name="email" value={form.email} onChange={this.handleChange} className="form-control" disabled={this.state.combosDisabled }/>
                                    </div>
                                    
                                    <TemPermissao permissao={ROLE_EMAIL}>
                                        <div className="form-group col-md-4">
                                            <label>Motivo:</label>
                                            <Select name="motivo" selected={form.motivo} data={this.state.comboMotivos} onChange={this.handleChange} placeholder="Motivo" disabled={ this.state.comboMotivoDisabled }  />
                                        </div>
                                    </TemPermissao>                                
                                </Row>

                                <Row className="form-row">
                                    <div className="form-group col-md-4">
                                        <label>{ this.state.labelDataInicio }</label>
                                        <InputMask mask="99/99/9999" name="dataInicio" value={form.dataInicio} placeholder="___/___/___" onChange={this.handleChange} disabled={ this.state.comboDataDisabled } className="form-control"/>
                                    </div>  

                                    <div className="form-group col-md-4">
                                        <label>{ this.state.labelDataFim }</label>
                                        <InputMask mask="99/99/9999" name="dataFim" value={form.dataFim} placeholder="___/___/___" onChange={this.handleChange} disabled={ this.state.comboDataDisabled } className="form-control"/>
                                    </div> 
                                    <div className="form-group col-md-4">
                                        <label>Centro de Custo:</label>
                                        <SelectCentroCusto name="centroCusto" selected={form.centroCusto.id} data={this.state.comboCentroCusto} onChange={this.handleChange} disabled={ this.state.comboCentroCustoDisabled } placeholder="Centro de Custo"  />
                                    </div>                              
                                </Row>

                                <Row className="form-row">
                                    <div className="form-group col-md-3">
                                        <label>Filtros:</label>
                                        <Select name="tipoRelatorio" selected={form.tipoRelatorio} data={this.state.comboTipoRelatorio} onChange={this.handleChangeCombo} placeholder="Tipo Relatório"  />
                                    </div>
                                    <div className="form-group col-md-1" style={{marginTop:'28px', marginLeft:"5px"}}>
                                        <Button onClick={this.handlePesquisarRelatorio}><Icon name="far fa-search"/> Pesquisar</Button>
                                    </div>
                                    <div className="form-group col-md-1" style={{marginTop:'28px', marginLeft:"40px"}}>
                                        <Button onClick={this.handlePesquisarRelatorioEmail} disabled={this.state.botaoDisabled}><Icon name="far fa-search"/>Relatório agendado</Button>
                                    </div>
                                    <div className="form-group col-md-1" style={{marginTop:'28px', marginLeft:"102px"}}>
                                        <Button onClick={this.handleLimparPesquisa}><Icon name="far fa-trash"/> Limpar</Button>
                                    </div>                                                             
                                </Row> 

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">                      
                                        {table}
                                    </Column>
                                </Row>                                

                            </Content>

                        </IBox>                     
                    </Column>
                </Row>


                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">                 
                                    
                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.pageSize}
                                        totalItemsCount={this.state.list.rowCount}
                                        onChange={this.handlePageChange}
                                        hideDisabled
                                    />

                                </div>
                            </Column>  
                        </Row>
                    </Column>
                </Row>

            </div>
        );
    }

    LoadListaCentroCusto(idEmpresa) {
        let self = this;

        const url = `${c.API_BASE_URL}/centroCusto-empresa/${idEmpresa}`;
        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboCentroCusto: response });
        });

    }

    LoadComboNomeCampanhas() {
        let self = this;

        const url = `${c.API_CAMPAIGN_URL}/public/campaign/campaign-name`;        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboNomeCampanhas: response });
            self.setState({ ...self.state, loading: false, comboNomeCampanhasAutoComplete: response.results });
        });
    }

    LoadComboEmpresa() {
        let self = this;
        const data = JSON.stringify({
            'nome_produto': CAMPANHA
        });
        const url = `${c.API_BASE_URL}/company-user`;
        const options =
        {
            method: 'POST'
            ,headers: { 'Content-Type': 'application/json' }
            ,body: data
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboEmpresa: response });
        });
    }

    LoadComboMotivos()
    {
        let self = this;

        const url = `${ c.API_BASE_URL }/reasonNotReceive`;
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, comboMotivos: response});
        });
    }

    LoadComboTipoRelatorio()
    {
        let self = this;

        const url = `${ c.API_BASE_URL }/typeReports`;
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, comboTipoRelatorio: response});
        });
    }

    LoadTable(pageNumber)
    {
        let self = this;
        self.setState({...self.state, list: self.listInitialState()});
        let pesquisa = pageNumber === undefined;
        let page = pageNumber === undefined ? 0 : --pageNumber;
        
        let relatorioNaoImplementado = 999;
        let tipoRelatorio = this.state.form.tipoRelatorio === "" || this.state.form.tipoRelatorio === "Selecione..." ? relatorioNaoImplementado : this.state.form.tipoRelatorio;
        let empresa = this.state.form.empresa === "Selecione..." ? "" : this.state.form.empresa;
        let status = this.state.form.status === "Selecione..." ? "" : this.state.form.status;
        let motivo = this.state.form.motivo === "Selecione..." ? "" : this.state.form.motivo;
        let centroCusto = this.state.form.centroCusto === "Selecione..." ? "" : this.state.form.centroCusto;

        if (this.tipoRelatorioNecessitaEmpresa(tipoRelatorio) && isBlank(empresa.id)) {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar o filtro empresa.");
            return;
        }

        const url = `${ c.API_BASE_URL }/relatorio`;
        const options =
        {
            method: 'POST' 
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({
                page: page,
                idCampanha: this.state.campanhaValues.value,
                idEmpresa:  empresa.id === 0 ? null : empresa.id,
                nomeContato: this.state.form.nomeContato,
                status: status,
                emailContato: this.state.form.email,
                motivo: motivo,
                dataEnvioInicio: this.state.form.dataInicio,
                dataEnvioFim: this.state.form.dataFim,
                tipoRelatorio: tipoRelatorio,
                tipoEnvio: 'Rastreado',
                idCentroCusto: centroCusto
            })
        };
    
        self.setState({...self.state, loading: true})
        
        callApi(url, options, function(response) {
            if (self.state.loading || self.state.novoAcesso) {
                self.setState({ ...self.state, loading: false, novoAcesso: false, list: response });
            }
        });  
       
    }

    paginacaoDetalhePorContatoSms(pageNumber) {
        const relatorio = this.state.listaDetalheContatoSms;
        const page = pageNumber === undefined || pageNumber === 0 ? 0 : pageNumber;
        const limit = 100;
        const slice1 = page * limit;
        const slice2 = limit * (page + 1);

        this.setState({
            ...this.state,
            list: {
                ...this.state.list
            }
        });
    }

    tipoRelatorioNecessitaEmpresa(tipoRelatorio) {
        return (tipoRelatorio === '3' || tipoRelatorio === '5' || tipoRelatorio === '6' || tipoRelatorio === '7' || tipoRelatorio === '10');
    }

    tipoRelatorioNecessitaDataInicio(tipoRelatorio) {
        return (tipoRelatorio === '9' || tipoRelatorio === '10' || tipoRelatorio === '0' || tipoRelatorio === 0 || tipoRelatorio === '11');
    }

    verificaData(inicio, fim) {
        const MILLISECOND = 1;
        const SECOND = MILLISECOND * 1000;
        const MINUTE = SECOND * 60;
        const HOUR = MINUTE * 60;
        const DAY = HOUR * 24;

        var inicioSplit = inicio.split("/");
        var fimSplit = fim.split("/");

        var dataInicial = new Date(inicioSplit[2], inicioSplit[1], inicioSplit[0]);
        var dataFim = new Date(fimSplit[2], fimSplit[1], fimSplit[0]);

        var milis = Math.abs(dataInicial.getTime() -
            dataFim.getTime());

        var meses = Math.floor(milis / DAY / 30);


        return meses;
    }

    LoadTableEmail()
    {
        let self = this;
        let page = 0;
        let relatorioNaoImplementado = 999;

       let tipoRelatorio = this.state.form.tipoRelatorio === "" || this.state.form.tipoRelatorio === "Selecione..."   ? relatorioNaoImplementado : this.state.form.tipoRelatorio;

        let empresa = this.state.form.empresa.id === undefined ? "" : this.state.form.empresa.id;
        let status = this.state.form.status === "Selecione..." ? "" : this.state.form.status;
        let motivo = this.state.form.motivo === "Selecione..." ? "" : this.state.form.motivo;
        let centroCusto = this.state.form.centroCusto.id === undefined ? "" : this.state.form.centroCusto.id;
        let idUsuario = self.props.auth.user.id;

        if (this.tipoRelatorioNecessitaDataInicio(tipoRelatorio) && isBlank(self.state.form.dataInicio)) {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar o filtro Data do envio da campanha (Início).");
            return;
        }
        if (isBlank(self.state.form.dataFim)) {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar o filtro Data do envio da campanha (Fim).");
            return
        }
        if (this.verificaData(this.state.form.dataInicio, this.state.form.dataFim) > 6) {
            c.TOASTER_INFO("Data inicial da rotina e Data final da rotina não deve ultrapassar 6 meses");
            return;
        }
        if(isBlank(empresa)) {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar a Empresa");
            return;
        } else {

            const url = `${ c.API_BASE_URL }/relatorio/email`;
            const options =
            {
                method: 'POST' 
                ,headers: { 'Content-Type': 'application/json' }
                ,body: JSON.stringify({
                    page: page,
                    idCampanha: this.state.form.campanha,
                    nomeCampanha: this.state.form.nomeCampanha,
                    idEmpresa:  empresa,
                    nomeContato: this.state.form.nomeContato,
                    status: status,
                    emailContato: this.state.form.email,
                    motivo: motivo,
                    dataEnvioInicio: this.state.form.dataInicio,
                    dataEnvioFim: this.state.form.dataFim,
                    tipoRelatorio: tipoRelatorio,
                    tipoEnvio: 'Rastreado',
                    idUsuario: idUsuario,
                    idCentroCusto: this.state.form.centroCusto
                })
            };

            callApi(url, options, function(response)
            { 
                if(response.status === 'OK'){
                    c.TOASTER_SUCCESS(response.message); 
                }else{
                    c.TOASTER_ERROR(response.message); 
                }
            });

        }
    }

}

function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EnvioRastreado));
